import React from "react"
import { Modal } from "react-bootstrap"
import styled from "styled-components"
import { getAssetPath } from "../../utils/assets"

const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 1rem 1rem;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
`

function SetItUpModal({
  show, onHide, getStartedHandler
}) {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered id="kajabi-instruction-modal">
      <Header>
        <button type="button" className="close" onClick={onHide}>
          <span aria-hidden="true">&times;</span>
        </button>
      </Header>
      <div className="modal-body pl-5 pr-5 pb-5">
        <h3 className="mb-3">How to connect to your program content</h3>
        <p className="mb-4">All your program content is hosted on our Strive:Stronger Digital Platform. To access this content, you just need to perform a few steps to get connected:</p>
        <p>1. Click on the &apos;Get Started&apos; button below. You will receive an email with the log in credentials for your new Strive:Stronger Digital Platform account.</p>
        <p>2. Copy and paste the username and password from this email to log in to the Strive:Stronger Digital Platform. We recommend that cookies are enabled so that accessing your program is seamless after this.</p>
        <p>3. You can now access your program content at any time by clicking &apos;Take Me There&apos; from your Performance Intelligence Academy dashboard.</p>

        <div className="mt-4 mb-5">
          <button className="btn btn-main" type="button" onClick={getStartedHandler}>
            Get Started
          </button>
        </div>

        <div className="mt-2 mb-2"><b>Did not receive a new account email?</b></div>
        <p>
          You may already have a Strive:Stronger Digital Platform account. Click the &quot;Get Started&quot; button above to log in.
        </p>
        <p className="mb-0">
          If you have forgotten your password, you can reset it by clicking on this
          {" "}
          <a href="https://portal.performanceintelligence.com/forgot-password" target="_blank" rel="noreferrer">link</a>
          .
        </p>
        <p className="mt-0">
          If you still have issues, contact
          {" "}
          <a href="mailto:support@performanceintelligence.com">support@performanceintelligence.com</a>
          .
        </p>
        <div className="mt-4">
          <button aria-label="Back" type="button" className="btn btn-outline-main" onClick={onHide}>
            <img src={getAssetPath("icn-back")} />
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default SetItUpModal